import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { fetchPosts, removePost } from '../../store/slices/post.slice'
import { PostList } from '../../cmps/PostSystem/PostList'
import toast from 'react-hot-toast'
import { useAuthorMap } from '../../hooks/useAuthorMap'
import { Loader } from '../../cmps/FarmerMotion/Loader'
import { PostIndexHelmet } from '../../cmps/Helments/PostIndexHelmet'

export function PostIndex() {
  const dispatch = useDispatch()
  const posts = useSelector((state) => state.postModule.posts)
  const isLoading = useSelector((state) => state.postModule.isLoading)
  const error = useSelector((state) => state.postModule.error)
  const authorMap = useAuthorMap()

  const [searchParams, setSearchParams] = useSearchParams()
  const [filterBy, setFilterBy] = useState({
    title: searchParams.get('title') || '',
    tags: searchParams.get('tags') ? searchParams.get('tags').split(',') : [],
  })

  useEffect(() => {
    dispatch(fetchPosts(filterBy)).unwrap().catch(console.error)
  }, [dispatch, filterBy])

  const handleSearch = (newFilterBy) => {
    setFilterBy(newFilterBy)
    const params = new URLSearchParams({
      title: newFilterBy.title || '',
      tags: newFilterBy.tags.join(','),
    })
    setSearchParams(params)
  }

  const handleRemovePost = async (postId) => {
    const confirmRemove = window.confirm('האם אתה בטוח שברצונך למחוק את הפוסט?')
    if (!confirmRemove) return

    try {
      await dispatch(removePost(postId)).unwrap()
      toast.success('הפוסט הוסר בהצלחה!')
    } catch (err) {
      toast.error(`שגיאה בהסרת הפוסט: ${err}`)
    }
  }

  if (isLoading) return <Loader />
  if (error) return <p>שגיאה בטעינת הפוסטים: {error}</p>

  return (
    <div>
      <PostIndexHelmet />
      <PostList
        posts={posts}
        onRemovePost={handleRemovePost}
        onSearch={handleSearch}
        filterBy={filterBy}
        authorMap={authorMap}
      />
    </div>
  )
}
